import React from 'react';
import './posts.scss';

const MidPPT = () => {
  return (
    <div className="evaluation-container">
      <h1>180DC Mid-Project Presentation</h1>
      <h3>Category: Student Activity</h3>
      <p className="date">Written on Wednesday, 5 Mar 2025, in the main library.</p>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/portfolio-bfe5b.appspot.com/o/180midpresentation.jpeg?alt=media&token=83be0f34-ec38-4fa7-a7d9-e2e5298a9ab7"
        alt="180-mid-presentation"
        className="cafe-image"
      />
      <p>
        Today, our team successfully completed our mid-project presentation, and I’m so proud of what we accomplished!
        Over the past week, we dedicated a lot of time to refining our presentation slides, deliverables, and how we wanted
        to lead the discussion. Since Objective 1 (which I’m working on) and Objective 3 are closely interconnected,
        we presented our progress and updates together, with Objective 2 following afterward. This was also my first time
        using Canvas to improve metrics and visuals, and it was incredibly helpful.
        <br/><br/>
        I’m pretty sure our team leader won’t find this page, but I just want to say how grateful I am to her.
        She put in so much time and effort, making sure everything was perfect before the presentation.
        I remember her name being called more than 15 times during our team meeting.
      </p>
      <p>
        Our clients were impressed with the quality of our research and the presentation, and they expressed their appreciation.
        They had a few technical questions, and I did my best to explain our deliverables clearly and ensure that we were all on the same page.
      </p>
      <p>
        One thing for improvement next time is being more mindful of the fact that our clients have different technical backgrounds from us.
        Some terms I use without thinking—like SQL or backend—might be unfamiliar to them. Since I handled most of the technical aspects of
        our project, I answered those questions from clients during the Q&A.
        <br/><br/>
        For the final presentation, I’ll make sure our deliverables and technical aspects are clear and accessible, ensuring that our clients
        feel confident and comfortable with the work, rather than overwhelmed. I’ll also prepare for potential questions in advance to make
        the discussion even smoother!
      </p>

    </div>
  );
};

export default MidPPT;